import request from "@/utils/request";
import { initGetParams } from "@/utils/index";

// 获取未读消息数量
export function getUnreadCount() {
  return request({
    url: "/credit/message/2001053001",
    method: "get",
  });
}

// 分页获取消息列表
export function getMessageList(data) {
  return request({
    url: `/credit/message/2001053002?${initGetParams(data)}`,
    method: "get",
  });
}

// 标记消息已读
export function markAsRead(data) {
  return request({
    url: "/credit/message/2001053003",
    method: "post",
    data,
  });
}

// 全部标记已读
export function markAllAsRead() {
  return request({
    url: "/credit/message/2001053004",
    method: "post",
  });
}
